// extracted by mini-css-extract-plugin
export default {"detailsContainer":"DetailFundraiserInformation_detailsContainer__6fwYD","label":"DetailFundraiserInformation_label__-GHgB"};